module.exports = __webpack_public_path__ + "img/import-modal-description.b96a7008.svg";